import { render, staticRenderFns } from "./detailed-provisions.vue?vue&type=template&id=03f3cb2b&scoped=true"
import script from "./detailed-provisions.vue?vue&type=script&lang=js"
export * from "./detailed-provisions.vue?vue&type=script&lang=js"
import style0 from "./detailed-provisions.vue?vue&type=style&index=0&id=03f3cb2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f3cb2b",
  null
  
)

export default component.exports